


  
  

  var faOffering = {
    prefix: 'fak',
    iconName: 'offering',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M583.9 312c-31.1-26.4-69.3-16.1-88.4-1.8l-60.4 45.5h-3.3c-.2-38-30.5-67.8-69.2-67.8h-144c-28.4 0-56.3 9.4-78.5 26.3L111.8 336H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80l41.3-31.5c14-10.7 31.4-16.5 49.4-16.5h144c27.9 0 29.1 40.2-1.1 40.2h-59.8c-7.6 0-13.8 6.2-13.8 13.8v.1c0 7.6 6.2 13.8 13.8 13.8h134.5c9.7 0 19.2-3.2 26.9-9l61.3-46.1c8.3-6.2 20.5-6.7 28.4 0 10.1 8.5 9.3 23.1-.9 30.7L451.4 455c-7.8 5.8-17.2 9-26.9 9H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h376.8c19.9 0 39.3-6.5 55.2-18.5l100.8-75.9c16.6-12.5 26.5-31.5 27.1-52 .7-20.5-8.1-40.1-24-53.6zM289.6 144.3l50.1 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.4 10.1 31.8 11.5V240c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.4-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50.1-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.4-10.1-31.8-11.5V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.4 31-49.3 63 2.9 23 20.6 41.3 42.9 47.7z'
      
    ]
  };

  

  
  

  var faRegularChartPieSimpleSparkle = {
    prefix: 'fak',
    iconName: 'regular-chart-pie-simple-sparkle',
    icon: [
      640,
      512,
      [],
      'e014',
      
      'M0 272C0 156.5 81.5 60.1 190.2 37.2 208.3 33.4 224 48.2 224 66.7l0 173.3 0 48 48 0 153.8 0-2.7 7.1-71.1 26.7c-8 3-14.9 7.9-20.3 14.2L224 336c-26.5 0-48-21.5-48-48l0-197.1c-74.6 26.4-128 97.5-128 181.1 0 106 86 192 192 192 47.2 0 90.5-17 123.9-45.3l50 18.8C370.2 483.4 308.4 512 240 512 107.5 512 0 404.6 0 272zM272 16.6c0-9 7-16.6 16-16.6 113.5 0 207.4 84.5 222 194-4.5-1.3-9.2-2-14-2-20.6 0-39 12.8-46.2 32l-6 16-171.8 0 0-223.4zM352 368c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faRegularChartSimpleHorizontalSparkle = {
    prefix: 'fak',
    iconName: 'regular-chart-simple-horizontal-sparkle',
    icon: [
      640,
      512,
      [],
      'e009',
      
      'M0 80l0 32c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80zM0 240l0 32c0 26.5 21.5 48 48 48l308.8 0 66.3-24.9 24.1-64.1c-4.2-22.2-23.7-39-47.2-39L48 192c-26.5 0-48 21.5-48 48zM0 400l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L48 352c-26.5 0-48 21.5-48 48zM48 80l288 0 0 32-288 0 0-32zm0 160l352 0 0 32-352 0 0-32zm0 160l160 0 0 32-160 0 0-32zm304-32c0 7.2 4.5 13.7 11.2 16.2L448 416 479.8 500.8c2.5 6.8 9 11.2 16.2 11.2s13.7-4.5 16.2-11.2L544 416 628.8 384.2c6.8-2.5 11.2-9 11.2-16.2s-4.5-13.7-11.2-16.2L544 320 512.2 235.2c-2.5-6.8-9-11.2-16.2-11.2s-13.7 4.5-16.2 11.2L448 320 363.2 351.8c-6.7 2.5-11.2 9-11.2 16.2z'
      
    ]
  };

  

  
  

  var faRegularChartTreeMapSparkle = {
    prefix: 'fak',
    iconName: 'regular-chart-tree-map-sparkle',
    icon: [
      640,
      512,
      [],
      'e012',
      
      'M0 80L0 192c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80zM0 320L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 272c-26.5 0-48 21.5-48 48zM48 80l128 0 0 112-128 0 0-112zm0 240l128 0 0 112-128 0 0-112zM256 80l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L304 32c-26.5 0-48 21.5-48 48zm0 160l0 32c0 26.5 21.5 48 48 48l52.8 0 66.3-24.9 8.7-23.1-127.8 0 0-32 139.8 0 6-16c5.2-14 16.4-24.6 30.1-29.3-5-1.7-10.3-2.7-15.9-2.7l-160 0c-26.5 0-48 21.5-48 48zm0 160l0 32c0 26.5 21.5 48 48 48l133.8 0-14.7-39.1-23.7-8.9-95.4 0 0-32 27.8 0c-7.4-8.6-11.7-19.7-11.8-31.6l0-.9c.1-5.4 1-10.6 2.6-15.5L304 352c-26.5 0-48 21.5-48 48zM304 80l160 0 0 32-160 0 0-32zm48 288c0 7.2 4.5 13.7 11.2 16.2L448 416 479.8 500.8c2.5 6.8 9 11.2 16.2 11.2s13.7-4.5 16.2-11.2L544 416 628.8 384.2c6.8-2.5 11.2-9 11.2-16.2s-4.5-13.7-11.2-16.2L544 320 512.2 235.2c-2.5-6.8-9-11.2-16.2-11.2s-13.7 4.5-16.2 11.2L448 320 363.2 351.8c-6.7 2.5-11.2 9-11.2 16.2z'
      
    ]
  };

  

  
  

  var faRegularFileLinesPen = {
    prefix: 'fak',
    iconName: 'regular-file-lines-pen',
    icon: [
      576,
      512,
      [],
      'e00e',
      
      'M0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.2 6.7 45.2 18.7l90.6 90.5c12 12 18.7 28.3 18.7 45.3l0 145.2-48 48 0-187.7-80 0c-17.7 0-32-14.3-32-32l0-80-160 0c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l198.5 0-5.1 20.2c-2.3 9.3-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 64zM96 280c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM289.5 492.1l15-60.1c1.4-5.7 4.3-10.8 8.4-14.9 43.1-43.1 86.2-86.1 129.2-129.2l71 71-129.2 129.2c-4.1 4.1-9.3 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2zM464.8 265.3l29.4-29.4c15.7-15.6 41-15.6 56.6 0l14.3 14.3c15.6 15.7 15.6 41 0 56.6l-29.4 29.4-70.9-70.9z'
      
    ]
  };

  

  
  

  var faRegularInputNumericSparkle = {
    prefix: 'fak',
    iconName: 'regular-input-numeric-sparkle',
    icon: [
      640,
      512,
      [],
      'e007',
      
      'M0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 192-4.9 0-43.1-16.2 0-175.8c0-8.8-7.2-16-16-16L64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l267.8 0c5.3 6.2 12.2 11.2 20.2 14.2l71.1 26.7 2.7 7.1-361.8 0c-35.3 0-64-28.7-64-64L0 128zM96 328c0-13.3 10.7-24 24-24l16 0 0-96-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zm146 9.6c-3.9-8.7-2.2-18.9 4.3-25.9l72-78c5.3-5.8 5.5-14.6 .3-20.5-6.5-7.4-18.3-6.8-24 1.2L283.5 230c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.8-33.3 72.3-35.6 99.2-4.9 21.3 24.4 20.9 60.9-1.1 84.7L318.8 304 352 304c8.2 0 15.5 4.1 19.8 10.4L352 321.8c-14.1 5.2-24.7 16.5-29.4 30.2L264 352c-9.5 0-18.1-5.7-22-14.4zM352 368c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faRegularMemoSparkle = {
    prefix: 'fak',
    iconName: 'regular-memo-sparkle',
    icon: [
      576,
      512,
      [],
      'e001',
      
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 164.8-24.9 66.3L336 303.8 336 64c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-15.8 23.1 8.7 15.3 40.8C363.1 499.9 343 512 320 512L64 512c-35.3 0-64-28.7-64-64L0 64zm96 88c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm192 24c0-7.2 4.5-13.7 11.2-16.2L384 320l31.8-84.8c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L480 320l84.8 31.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L480 416l-31.8 84.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L384 416l-84.8-31.8c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faRegularPenSparkle = {
    prefix: 'fak',
    iconName: 'regular-pen-sparkle',
    icon: [
      640,
      512,
      [],
      'e015',
      
      'M1 481.2l12.4-42.2 23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.8 19.3c25-25 65.5-25 90.5 0l39.4 39.5c3.1 3.1 5.9 6.5 8.2 10 16.4 24.9 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8-9.7 8.5-21 14.8-33.4 18.4l-78.1 23-42.3 12.5c-8.4 2.4-17.5 .1-23.7-6.1s-8.5-15.3-6-23.8zm58.4-28.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.1 1.2-1.7 1.8-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4-16.1 54.8zM352 368c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faRegularSquarePollVerticalSparkle = {
    prefix: 'fak',
    iconName: 'regular-square-poll-vertical-sparkle',
    icon: [
      640,
      512,
      [],
      'e011',
      
      'M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 132.8-24.9 66.3-23.1 8.7 0-207.8c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c3.2 0 6.1-.9 8.6-2.5l30.5 11.4 7.2 19.2C418.7 472.4 402.2 480 384 480L64 480c-35.3 0-64-28.7-64-64L0 96zM104 248c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112zm96-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm96 160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 13.6c-14.6 8.7-23.8 24.5-24 41.9l0 .9c.1 5.4 1 10.6 2.6 15.5-.9 .1-1.7 .1-2.6 .1-13.3 0-24-10.7-24-24l0-48zm56 56c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faRegularTableColumnsSparkle = {
    prefix: 'fak',
    iconName: 'regular-table-columns-sparkle',
    icon: [
      640,
      512,
      [],
      'e00f',
      
      'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 98.7c-5.1-1.7-10.4-2.7-16-2.7-12 0-23.3 4.3-32 11.8l0-43.8-184 0 0 272 119.4 0 23.7 8.9 14.7 39.1-373.8 0c-35.3 0-64-28.7-64-64L0 96zm48 64l0 256c0 8.8 7.2 16 16 16l168 0 0-272-184 0zM352 368c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faSentenceSparkle = {
    prefix: 'fak',
    iconName: 'sentence-sparkle',
    icon: [
      768,
      512,
      [],
      'e00a',
      
      'M0 36.6C0 56.8 17.2 73.1 38.4 73.1l460.8 0c21.2 0 38.4-16.3 38.4-36.6S520.4 0 499.2 0L38.4 0C17.2 0 0 16.3 0 36.6zM0 219.4C0 239.7 17.2 256 38.4 256l460.8 0c4.3 0 8.6-.7 12.5-1.9l20.9-52.8c-6.6-11-19.1-18.4-33.4-18.4l-460.8 0C17.2 182.9 0 199.2 0 219.4zm422.4 128c0 8.2 5.4 15.7 13.4 18.5l101.8 36.3 38.2 96.9c3 7.8 10.8 12.8 19.4 12.8s16.4-5.1 19.4-12.8l38.2-96.9 101.8-36.3c8.2-2.9 13.4-10.3 13.4-18.5s-5.4-15.7-13.4-18.5l-101.8-36.3-38.2-96.9c-3-7.8-10.8-12.8-19.4-12.8s-16.4 5.1-19.4 12.8l-38.2 96.9-101.8 36.3c-8 2.9-13.4 10.3-13.4 18.5zM0 402.3c0 20.2 17.2 36.6 38.4 36.6l191.2 0c25.5 0 42.4-16.3 42.4-36.6s-12.9-36.3-42.4-36.3-191.2-.2-191.2-.2C17.2 365.7 0 382.1 0 402.3z'
      
    ]
  };

  

  
  

  var faSolidBarsSparkle = {
    prefix: 'fak',
    iconName: 'solid-bars-sparkle',
    icon: [
      640,
      512,
      [],
      'e004',
      
      'M0 96c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 64C14.3 64 0 78.3 0 96zM0 256c0 17.7 14.3 32 32 32l384 0c3.6 0 7.2-.6 10.4-1.7l17.4-46.2c-5.5-9.6-15.9-16.1-27.8-16.1L32 224c-17.7 0-32 14.3-32 32zM0 416c0 17.7 14.3 32 32 32l384 0c3.2 0 6.3-.5 9.3-1.4l-2.2-5.7L352 414.2c-14-5.3-24.6-16.5-29.3-30.2L32 384c-17.7 0-32 14.3-32 32zm352-48c0 7.2 4.5 13.7 11.2 16.2L448 416l31.8 84.8c2.5 6.8 9 11.2 16.2 11.2s13.7-4.5 16.2-11.2L544 416l84.8-31.8c6.8-2.5 11.2-9 11.2-16.2s-4.5-13.7-11.2-16.2L544 320l-31.8-84.8c-2.5-6.8-9-11.2-16.2-11.2s-13.7 4.5-16.2 11.2L448 320l-84.8 31.8c-6.7 2.5-11.2 9-11.2 16.2z'
      
    ]
  };

  

  
  

  var faSolidMemoSparkle = {
    prefix: 'fak',
    iconName: 'solid-memo-sparkle',
    icon: [
      576,
      512,
      [],
      'e002',
      
      'M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 164.8-24.9 66.3L288 321.8c-19.1 7.1-31.8 25.3-32 45.7l0 .9c.2 20.4 12.9 38.6 32 45.8l71.1 26.7 15.3 40.8C363.1 499.9 343 512 320 512L64 512c-35.3 0-64-28.7-64-64L0 64zm64 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 128c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 224c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 320c-8.8 0-16 7.2-16 16zm224 32c0-7.2 4.5-13.7 11.2-16.2L384 320l31.8-84.8c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L480 320l84.8 31.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L480 416l-31.8 84.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L384 416l-84.8-31.8c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  

  
  

  var faSolidPenSparkle = {
    prefix: 'fak',
    iconName: 'solid-pen-sparkle',
    icon: [
      640,
      512,
      [],
      'e00d',
      
      'M1 481.2L36.4 360.9c4.2-14.1 11.8-27 22.2-37.4l233.1-233.2 130 130-233.3 233.2c-10.4 10.4-23.3 18-37.4 22.2L30.7 511.1c-8.4 2.4-17.5 .1-23.7-6.1s-8.5-15.3-6-23.8zM314.3 67.7c16.1-16.1 32.3-32.3 48.5-48.4 25-25 65.5-25 90.5 0l39.4 39.5c25 25 25 65.5 0 90.5l-48.4 48.4-130-130zM352 368c0-7.2 4.5-13.7 11.2-16.2L448 320 479.8 235.2c2.5-6.7 9-11.2 16.2-11.2s13.7 4.4 16.2 11.2L544 320 628.8 351.8c6.7 2.5 11.2 9 11.2 16.2s-4.4 13.7-11.2 16.2L544 416 512.2 500.8c-2.5 6.7-9 11.2-16.2 11.2s-13.7-4.4-16.2-11.2L448 416 363.2 384.2c-6.7-2.5-11.2-9-11.2-16.2z'
      
    ]
  };

  



export {

  faOffering,
  

  faRegularChartPieSimpleSparkle,
  

  faRegularChartSimpleHorizontalSparkle,
  

  faRegularChartTreeMapSparkle,
  

  faRegularFileLinesPen,
  

  faRegularInputNumericSparkle,
  

  faRegularMemoSparkle,
  

  faRegularPenSparkle,
  

  faRegularSquarePollVerticalSparkle,
  

  faRegularTableColumnsSparkle,
  

  faSentenceSparkle,
  

  faSolidBarsSparkle,
  

  faSolidMemoSparkle,
  

  faSolidPenSparkle,
  

};
